import { Typography } from "@mui/material";
import React from "react";
import uploadSuccess from "../../../assets/images/videoUploadSuccess.svg";
import "./videoupload.scss";
import { useNavigate } from "react-router-dom";
import { PERSON_DASHBOARD } from "../../../routes/routerPath";
import { searchParams, handleParams } from "../../../utlis/helpers";
import { pageLocale } from "../../../utlis/locale";
import { userInfoFetch } from "../../../utlis/commonFunction";

const VideoUploadedSuccess = ({ styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");
  const navigate = useNavigate();
  const { upload_success, alert_info, done } = pageLocale("videoUpload");

  const doneHandler = () => {
    sessionStorage.setItem("romStatus", "");
    sessionStorage.setItem("romReportId", "");
    const seniorId = userInfoFetch()?.id;
    if (seniorId) {
      navigate(PERSON_DASHBOARD + handleParams("seniorId", seniorId));
    } else {
      navigate(PERSON_DASHBOARD + `${searchParams}`);
    }
  };

  return (
    <div className="video-upload-status-wrappper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <div className={`video-upload-content-wrap`}>
        <img src={uploadSuccess} alt="success" className="img" />
        <Typography className="success-msg">{upload_success}</Typography>
        <Typography className="report-msg">{alert_info}</Typography>
        <button onClick={() => doneHandler()} className="done-btn">
          {done}
        </button>
      </div>
    </div>
  );
};

export default VideoUploadedSuccess;
